export type ApiUrl = `/api/${string}`;
export const isApiUrl = (url: string): url is ApiUrl => ['/api/', 'api/'].some(x => url?.startsWith(x));
